import { createContext, use } from 'react';
import { type Locale, type MeResponse } from '@aps/contracts';

/**
 * Joriy sessiya konteksti.
 *
 * `App.tsx` sessiya yo'q bo'lsa kirish ekranini ko'rsatadi, shuning
 * uchun kontekst ichida `me` HAR DOIM mavjud — ekranlarda `me?.` yozish
 * kerak emas. `null` qiymat faqat Provider'siz ishlatilganda bo'ladi va
 * u xato hisoblanadi.
 */
export interface SessionValue {
  me: MeResponse;
  locale: Locale;
  setLocale: (locale: Locale) => void;
  signOut: () => void;
}

export const SessionContext = createContext<SessionValue | null>(null);

export function useSession(): SessionValue {
  const value = use(SessionContext);
  if (value === null) throw new Error('useSession faqat SessionContext ichida ishlaydi');
  return value;
}
